// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ag-theme-material .ag-icon-checkbox-checked{color:#337ab7 !important}\n", ""]);
// Exports
module.exports = exports;
